import _ from 'lodash'

export const initialState = {
  filter: '',
  category: 'all',
  putters: [],
  loading: true,
}

export const setPutterFilterText = (state, filter) =>{
  return Object.assign({}, state, {filter});
}

export const setPutterFilterCategory = (state, category) =>{
  return Object.assign({}, state, {category});
}

export const setPutters = (state, putters) => {
  return Object.assign({}, state, { putters, filter: '', category: 'all' });
}

function getMatches(keywords, label) {
  return _(keywords)
    .map((q) => {
      let m, a = [], re = new RegExp(q.replace(/\./g, '\\.'), 'gi');
      while (m = re.exec(label)) { // eslint-disable-line no-cond-assign
        a.push({ start: m.index, length: q.length, q });
      }
      return a;
    })
    .flatten()
    .filter()
    .value();
}

// Label only matches if every word in the query produces at least one match
// Can't just check matches.length, because one word might match multiple times
function doesLabelMatch(keywords, label) {
  const m = getMatches(keywords, label);
  return _.reduce(keywords, (v, q) => v && _.find(m, { q }), true)
}

export const getFilteredPutters = (state) => {
  const query = (state.filter || '').trim()
  let filteredPutters, returnPutters;
  if (!query) {
    filteredPutters = _(state.putters)
    .map((putter) => {
      return {
        ...putter,
        matches: [],
        keywords: [],
      }
    })
    .value();
  } else {
    let keywords = query.split(' ');
    _(state.putters).filter((putter) => (putter.template_id && putter.template_id < 1));
    filteredPutters = _(state.putters)
      .filter((putter) => (
        doesLabelMatch(keywords, putter.label)))
      .map((putter) => {
        return {
          ...putter,
          matches: getMatches(keywords, putter.label),
          keywords: keywords
        }
      })
      .value();
  }

  // TODO:  This may be better to pull out into a new action, instead of this.
  //        Since this buy category no longer uses the text filter.

  // Check category for filtering
  // This is the "buy_a_putter" option
  switch (state.category) { 
    case 'buy':
      // 1 = Buy, , buy_a_putter:true
      // Don't use the search filter here, so filter from all putters
      filteredPutters = _(state.putters)
      .map((putter) => {
        return {
          ...putter,
          matches: [],
          keywords: [],
        }
      })
      .value();
      returnPutters = _.filter(filteredPutters, { 'buy_a_putter': true });
      break;
    case 'all': 
    default:
      // 0 is View All
      // Do nothing and break
      returnPutters = _.filter(filteredPutters, { 'buy_a_putter': false });
      break;
  }

  return returnPutters;
}


export const test = {
  getMatches,
  doesLabelMatch 
}